import { useEffect, useState } from "react";
import TableFilter from "./TableFilter";
import { message, Table } from "antd";
import config from "../../../config";
import "./styles/supercodes.css";
import dayjs from "dayjs";
import { CopyOutlined } from "@ant-design/icons";
import deleteButton from "./styles/img/delete_button.svg";
import EditSuperCodeModal from "./editSuperCodeModal";
import DeleteSuperCodeModal from "./deleteCodeModal";
const base_url = config.base_url;

function SuperCodesTable({
  open,
  tableData,
  tableLoading,
  setTableData,
  formateSuperCodeTableData,
}) {
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };
  const [promotionTypeFilter, setPromotionTypeFilter] = useState(undefined);
  const [createdByFilter, setCreatedByFilter] = useState(undefined);
  const [adminsNames, setAdminsNames] = useState([]);
  const [loadingAdminNames, setLoadingAdminNames] = useState(true);
  const [editedCoupon, setEditedCoupon] = useState(undefined);
  const [deletedCoupon, setDeletedCoupon] = useState(undefined);
  const [filteredData, setFilteredData] = useState(tableData);
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [openEditCodeModal, setOpenEditCodeModal] = useState(false);
  const [openDeleteCodeModal, setOpenDeleteCodeModal] = useState(false);
  const closeEditCodeModalHandler = () => {
    setOpenEditCodeModal(false);
    setEditedCoupon(undefined);
  };
  const openEditCodeModalHandler = () => {
    setOpenEditCodeModal(true);
  };

  const closeDeleteCodeModalHandler = () => {
    setOpenDeleteCodeModal(false);
    setDeletedCoupon(undefined);
  };
  const openDeleteCodeModalHandler = (code) => {
    setOpenDeleteCodeModal(true);
    setDeletedCoupon(code);
  };

  useEffect(() => {
    setFilteredData(tableData);
  }, [tableData]);
  const columns = [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    {
      key: "1",
      title: "Creation Date",
      dataIndex: "date",

      //   onFilter: (value, record) => {
      //     return record.partner_name.includes(value);
      //   },0
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <p
              style={{
                margin: "0",
              }}
              data-openpopup={"no"}
              onClick={(e) => {}}
            >
              <span data-openpopup={"no"}>
                {record.index}.&nbsp;&nbsp;&nbsp;
              </span>
              <span data-openpopup={"no"}>
                {dayjs(text[0].date).format("YYYY-MM-DD")}
              </span>
            </p>
          </div>
        );
      },
    },
    {
      key: "2",
      title: "Created By",
      dataIndex: "created_by_full_name",

      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span>{text}</span>
          </div>
        );
      },
      //     if (!text) return <span>{text}</span>;
      //     if (text === "agency") {
      //       return <span> Legal Advisor</span>;
      //     }
      //     return <span> {text.charAt(0).toUpperCase() + text.slice(1)}</span>;
      //   },
    },
    {
      key: "3",
      title: "Active",
      dataIndex: "status",
      render: (text, record, index) => {
        if (record.status == "expired") {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(255, 0, 0, 1)",
                }}
              >
                Expired
              </span>
            </div>
          );
        } else if (record.status == "inactive") {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(128, 0, 131, 1)",
                }}
              >
                Inactive
              </span>
            </div>
          );
        }

        const formattedText = `${
          record.totalUsedBy.length
        }/${+record.totalUsage}`;
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span
              style={
                record.totalUsedBy.length === 0
                  ? {}
                  : {
                      color: "rgba(65, 159, 35, 1)",
                    }
              }
            >
              {formattedText}
            </span>
          </div>
        );
      },
      //     if (text === undefined) return <p style={{ textAlign: "left" }}>-</p>;
      //     return (
      //       <p>
      //         {Math.abs(text) > 999
      //           ? Math.sign(text) * (Math.abs(text) / 1000).toFixed(1) + "k"
      //           : Math.sign(text) * Math.abs(text)}
      //       </p>
      //     );
      //   },
    },
    {
      key: "4",
      title: "Code",
      dataIndex: "codeNames",
      render: (text, record, index) => {
        // return <></>;
        if (record.codeNames.length === 0) {
          return (
            <span
              style={{
                color: "rgba(255, 0, 0, 1)",
              }}
            >
              -
            </span>
          );
        } else if (record.codeNames.length === 1) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <span>{text[0]}</span>{" "}
            </div>
          );
        }

        if (!record.expanded) {
          return (
            <div
              data-openpopup={"no"}
              onClick={() => {
                setTableData((prev) => {
                  const index = prev.findIndex((item) => {
                    return item.coupon_family === record.coupon_family;
                  });

                  if (index !== -1) {
                    const updatedItem = {
                      ...prev[index],
                      expanded: true,
                    };
                    const updatedArray = [
                      ...prev.slice(0, index),
                      updatedItem,
                      ...prev.slice(index + 1),
                    ];
                    return updatedArray;
                  }
                });
              }}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                data-openpopup={"no"}
                style={{
                  color: "rgba(0, 145, 234, 1)",
                  textDecoration: "underline",
                }}
              >
                Multiple (expand)
              </span>
            </div>
          );
        } else
          return (
            <div
              data-openpopup={"no"}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              onClick={() => {
                setTableData((prev) => {
                  const index = prev.findIndex((item) => {
                    return item.coupon_family === record.coupon_family;
                  });

                  if (index !== -1) {
                    const updatedItem = {
                      ...prev[index],
                      expanded: false,
                    };
                    const updatedArray = [
                      ...prev.slice(0, index),
                      updatedItem,
                      ...prev.slice(index + 1),
                    ];
                    return updatedArray;
                  }
                });
              }}
            >
              {text.map((text) => (
                <span data-openpopup={"no"}>{text}</span>
              ))}
            </div>
          );
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span style={{ color: "rgba(0, 145, 234, 1)" }}>{text}</span>
          </div>
        );
      },
    },
    {
      key: "5",
      title: "Promotion Description",
      dataIndex: "description",
      render: (text, record, index) => {
        if (record.recurrent && record.description === undefined) {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span>Unlimited Time</span>
            </div>
          );
        }
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span>{text}</span>
          </div>
        );
      },
    },
    {
      key: "6",
      title: "Permanent or one time",
      dataIndex: "formattedRecurrent",
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                textTransform: "capitalize",
              }}
            >
              {text}
            </span>
          </div>
        );
      },
    },
    {
      key: "7",
      title: "Used by",
      dataIndex: "totalUsedBy",
      // sorter: (a, b) => {
      //   return a.status.localeCompare(b.status);
      // },

      render: (text, record, index) => {
        if (record.totalUsedBy.length === 0) {
          return (
            <span
              style={{
                color: "rgba(255, 0, 0, 1)",
              }}
            >
              -
            </span>
          );
        } else if (record.totalUsedBy.length === 1) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <span>{text[0].customer_email}</span>{" "}
            </div>
          );
        }

        if (!record.expanded) {
          return (
            <div
              data-openpopup={"no"}
              onClick={() => {
                setTableData((prev) => {
                  //   return {
                  //     ...prev,
                  //     [record.id]: {
                  //       ...prev[record.id],
                  //       expanded: true,
                  //     },
                  //   };
                  const index = prev.findIndex((item) => {
                    return item.coupon_family === record.coupon_family;
                  });

                  if (index !== -1) {
                    const updatedItem = {
                      ...prev[index],
                      expanded: true,
                    };
                    const updatedArray = [
                      ...prev.slice(0, index),
                      updatedItem,
                      ...prev.slice(index + 1),
                    ];

                    return updatedArray;
                  }
                });
              }}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                data-openpopup={"no"}
                style={{
                  color: "rgba(0, 145, 234, 1)",
                  textDecoration: "underline",
                }}
              >
                Multiple (expand)
              </span>
            </div>
          );
        } else
          return (
            <div
              data-openpopup={"no"}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
              }}
              onClick={() => {
                setTableData((prev) => {
                  const index = prev.findIndex((item) => {
                    return item.coupon_family === record.coupon_family;
                  });

                  if (index !== -1) {
                    const updatedItem = {
                      ...prev[index],
                      expanded: false,
                    };
                    const updatedArray = [
                      ...prev.slice(0, index),
                      updatedItem,
                      ...prev.slice(index + 1),
                    ];
                    return updatedArray;
                  }
                });
              }}
            >
              {text.map((text) => (
                <span data-openpopup={"no"}>{text.customer_email}</span>
              ))}
            </div>
          );
      },
    },
    {
      key: "8",
      title: "User Status",
      dataIndex: "user_status",
      sorter: (a, b) => {
        // return a.email_address.localeCompare(b.email_address);
      },
      render: (text, record, index) => {
        const getUserStatus = (user) => {
          if (user.code_type !== "supercode") {
            return (
              <span
                style={{
                  color: "rgba(255, 0, 0, 1)",
                  textTransform: "capitalize",
                }}
              >
                -
              </span>
            );
          }
          if (
            user.customer_status === "trial" ||
            user.customer_status === "invitation"
          ) {
            return (
              <span
                style={{
                  color: "rgba(105, 0, 155, 1)",
                }}
              >
                User created
              </span>
            );
          } else if (user.customer_status === "subscription") {
            return (
              <span
                style={{
                  color: "rgba(65, 159, 35, 1)",
                  textTransform: "capitalize",
                }}
              >
                Paid subscription
              </span>
            );
          } else if (user.customer_status == "freezed") {
            return (
              <span
                style={{
                  color: "rgba(178, 6, 6, 1)",
                  textTransform: "capitalize",
                }}
              >
                Freezed account
              </span>
            );
          }
        };
        if (record.totalUsedBy.length === 0) {
          return (
            <span
              style={{
                color: "rgba(255, 0, 0, 1)",
              }}
            >
              -
            </span>
          );
        } else if (
          record.totalUsedBy.length !== 0 &&
          record.totalUsedBy.length === 1 &&
          record.totalUsage === 1
        ) {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(105, 0, 155, 1)",
                  textTransform: "capitalize",
                }}
              >
                {getUserStatus(record.totalUsedBy[0])}
              </span>
            </div>
          );
        } else if (
          record.totalUsedBy.length !== 0 &&
          record.totalUsedBy.length !== record.totalUsage &&
          !record.expanded
        ) {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(105, 0, 155, 1)",
                  textTransform: "capitalize",
                }}
              >
                Partially used
              </span>
            </div>
          );
        } else if (
          record.totalUsedBy.length !== 0 &&
          record.totalUsedBy.length == record.totalUsage &&
          !record.expanded
        ) {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(65, 159, 35, 1)",
                  textTransform: "capitalize",
                }}
              >
                {getUserStatus(record.totalUsedBy[0])}
              </span>
            </div>
          );
        }

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {record.totalUsedBy.map((record) => {
              return getUserStatus(record);
            })}
          </div>
        );
      },
    },
    {
      key: "9",
      title: "Created for",
      dataIndex: "created_for",
      sorter: (a, b) => {
        // return a.email_address.localeCompare(b.email_address);
      },
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <span>{text}</span>
          </div>
        );
      },
    },
    {
      key: "10",
      title: "Copy URL Code",
      dataIndex: "copy_code",
      disableSortBy: true,
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <CopyOutlined
              data-openpopup={"no"}
              onClick={() => {
                const url = record.codeNames
                  .map((code) => {
                    return `${window.location.origin}/register/?referral=${code}`;
                  })
                  .join("\n");

                navigator.clipboard.writeText(url);
                success(`(${url}) Copied`);
              }}
              style={{
                color: "rgb(0, 145, 234)",
                cursor: "pointer",
                textAlign: "right !important",
                transform: "scale(1.3)",
              }}
            />
          </div>
        );
      },
    },
    {
      key: "11",
      title: "Actions",
      dataIndex: "actions",
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <img
              data-openpopup={"no"}
              src={deleteButton}
              alt="delete"
              onClick={() => {
                openDeleteCodeModalHandler(record.coupon_family);
              }}
            />
          </div>
        );
      },
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ];
  useEffect(() => {
    setLoadingAdminNames(true);
    fetch(base_url + "admin/users", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `filter_value=${""}&filter_field=${""}&max_date=${""}&min_date=${""}&nlogs=${""}&page=${""}&sort=${""}`,
      credentials: "include",
    }).then((res) =>
      res
        .json()
        .then((res) => {
          const names = [];
          res.result.data.forEach((admin) => {
            names.push({ value: admin.full_name, label: admin.full_name });
          });
          setAdminsNames(names);
          setLoadingAdminNames(false);
        })
        .catch((err) => {
          console.log(err);
          setLoadingAdminNames(false);
        })
    );
  }, []);
  useEffect(() => {
    let filterTable = tableData.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(globalSearch.toLowerCase())
      )
    );
    if (promotionTypeFilter) {
      filterTable = filterTable.filter(
        (item) => item.formattedRecurrent === promotionTypeFilter
      );
    }
    if (createdByFilter) {
      filterTable = filterTable.filter(
        (item) => item.created_by_full_name === createdByFilter
      );
    }
    setFilteredData(filterTable);
  }, [globalSearch, promotionTypeFilter, createdByFilter, tableData]);
  const globalSearchFunction = (value) => {
    setGlobalSearch(value);
  };

  return (
    <>
      {contextHolder}
      <TableFilter
        component={"superCodes"}
        globalSearch={globalSearchFunction}
        setPromotionTypeFilter={setPromotionTypeFilter}
        createdByOptions={adminsNames}
        loadingAdminNames={loadingAdminNames}
        setCreatedByFilter={setCreatedByFilter}
      />
      <Table
        className="superCodesDataTable"
        // loading={tableLoading}
        onRow={(record, rowIndex) => {
          return {
            onClick: (e) => {
              if (
                e.target.dataset.openpopup === "no" ||
                e.target.dataset.icon === "copy"
              )
                return;
              openEditCodeModalHandler();
              setEditedCoupon(record);
              //   setUserId(record.user_id);
              //   setModalOpened(true);
              //   setPopupData(record);
            },
          };
        }}
        rowClassName="td"
        columns={columns}
        dataSource={filteredData}
        pagination={{
          className: "partnerDataPagination",
          locale: { items_per_page: "" },
          pageSize: pageSize,
          current: page,
          showSizeChanger: true,
          total: tableData.length,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
          showTotal: (total, range) => {
            return `Page ${page} of ${Math.ceil(total / pageSize)}`;
          },
          itemRender: (page, type, originalElement) => {
            if (type === "next") return <span>Next</span>;
            if (type === "prev") return <span>Previous</span>;
            if (type === "page") return null;
            return originalElement;
          },
        }}
        loading={tableLoading}
      ></Table>

      <EditSuperCodeModal
        open={openEditCodeModal}
        closeModal={closeEditCodeModalHandler}
        editedCoupon={editedCoupon}
        formateSuperCodeTableData={formateSuperCodeTableData}
        setTableData={setTableData}
      />

      <DeleteSuperCodeModal
        open={openDeleteCodeModal}
        closeModal={closeDeleteCodeModalHandler}
        deletedCoupon={deletedCoupon}
        setTableData={setTableData}
        formateSuperCodeTableData={formateSuperCodeTableData}
      />
    </>
  );
}

export default SuperCodesTable;
